export default __webpack_public_path__ + "static/media/wavingEmoji.d26a006b.png";